const $ = jQuery.noConflict();

class SelectRandomItem {
    constructor(wrapper, items) {
        this.wrapper = wrapper;
        this.items = items;
    }
    init() {
        const wrapper = $(this.wrapper);
        const items = wrapper.find(this.items);
        const numberOfItems = items.length;
        const randIndex = Math.floor(Math.random() * numberOfItems);
        
        items.eq(randIndex).addClass('is-visible');
    }
}

export default new SelectRandomItem('.aside-link', '.aside-link-subtitle');